module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eSouz"))).then(() => parcelRequire('d0iPb'));